/** Parses the first integer before a '.' */
export function parseMajorVersion(version?: string): number {
  if (!version) {
    return 0;
  }
  const dotIndex = version.indexOf('.');
  return Number(dotIndex >= 0 ? version.substring(0, dotIndex) : version);
}
